import {NgModule} from "@angular/core";
import {CommonModule, HashLocationStrategy, Location, LocationStrategy} from "@angular/common";
import {RouterModule} from "@angular/router";
import {NavLayoutComponent} from "./main/nav-layout/nav-layout.component";
import {MainRoutes} from "./main/main.routing";
import {LoginPageComponent} from "./fonzie/login/login-page/login-page.component";
import {SignupPageComponent} from "./fonzie/signup/signup-page/signup-page.component";
import {CustomerPortalRoutes} from "./fonzie/customer-portal/customer-portal.routing";
import {CustomerPortalPageComponent} from "./fonzie/customer-portal/customer-portal/customer-portal-page.component";
import {
    AppPaymentAccountPageComponent
} from "./fonzie/app-payment-account/app-payment-account-page/app-payment-account-page.component";
@NgModule({
    imports: [
        CommonModule,
        [RouterModule.forRoot([
            {
                component: LoginPageComponent,
                path: "login"
            },
            {
                path: "main",
                children: MainRoutes,
                component: NavLayoutComponent
            },
            {
                path: "signup",
                component: SignupPageComponent
            },
            {
                path: "customer-portal",
                children: CustomerPortalRoutes,
                component: CustomerPortalPageComponent
            },
            {
                path: "app-payment-account",
                component: AppPaymentAccountPageComponent
            },
            {
                path: "",
                pathMatch: "full",
                redirectTo: "main"
            }
        ])]
    ],
    exports: [
        RouterModule
    ],
    providers: [
        Location,
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy
        }
    ]
})
export class AppRoutingModule {
}
